// Simple Hash-based SPA Router

const routes = {};
let currentRoute = null;
let notFoundHandler = null;

export function registerRoute(path, handler) {
    routes[path] = handler;
}

export function setNotFound(handler) {
    notFoundHandler = handler;
}

export function navigate(path) {
    window.location.hash = path;
}

export function getCurrentRoute() {
    return currentRoute;
}

function parseRoute(hash) {
    const path = hash.replace('#', '') || '/home';
    const parts = path.split('/').filter(Boolean);

    // Check exact match first
    if (routes['/' + parts.join('/')]) {
        return { handler: routes['/' + parts.join('/')], params: {} };
    }

    // Check parameterized routes
    for (const [pattern, handler] of Object.entries(routes)) {
        const patternParts = pattern.split('/').filter(Boolean);
        if (patternParts.length !== parts.length) continue;

        const params = {};
        let match = true;

        for (let i = 0; i < patternParts.length; i++) {
            if (patternParts[i].startsWith(':')) {
                params[patternParts[i].slice(1)] = parts[i];
            } else if (patternParts[i] !== parts[i]) {
                match = false;
                break;
            }
        }

        if (match) return { handler, params };
    }

    return { handler: notFoundHandler, params: {} };
}

export function startRouter() {
    const handleRoute = () => {
        const hash = window.location.hash || '#/home';
        const { handler, params } = parseRoute(hash);
        currentRoute = hash.replace('#', '');

        if (handler) {
            handler(params);
        } else if (notFoundHandler) {
            notFoundHandler();
        }
    };

    window.addEventListener('hashchange', handleRoute);
    handleRoute();
}
